import _ from 'lodash';
import angular from 'angular';
import $ from 'jquery';

const backEndServiceFactory = function backEndServiceFactory($rootScope, $q, $log, $http, Environment, ValidazioneService, StorageService, NewTokenService) {
    "ngInject";

    return {
      /**
       * invokeWebApiPost - chiama il backend
       *
       * @param  {string} servicePath
       * @param  {object} dataRequest
       * @param  {boolean} isBackground (per mostrare o meno il loader)
       * @param  {boolean} forceConsumer (per forzare la chamata ad essere verso il consumer)
       *
       * @return {Promise}
       */
      invokeWebApiPost: function(servicePath, dataRequest, isBackground, forceConsumer = false, ignoreError = false, promiseForCancel = false) {
        $rootScope.$broadcast('xhr');
        const url = Environment.endPoints.baseUrl+servicePath;
        $log.debug(`url Servizio: ${url}`);
        dataRequest = dataRequest || {}; //eslint-disable-line no-param-reassign

        const extraOptions = {};
        if (isBackground === true) {
          extraOptions.isBackground = true;
        } else {
          extraOptions.isBackground = false;
        }

        // Parametro per cancellare le request
       if (promiseForCancel) {
         extraOptions.timeout = promiseForCancel;
       }
       extraOptions.headers = [];
       extraOptions.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token');
       extraOptions.customErrorManagement = ignoreError;
       NewTokenService.setLastUserAction();
        return $http.post(url, dataRequest, extraOptions)
          .then(function(response) { //eslint-disable-line no-unused-vars
            $log.debug(response);
            return response;
          }, (error) => {
            if(error.status == 401 || error === "Token has expired."){
              $rootScope.$broadcast('event:auth-renewTokenRequired');
            }
            if (error.data === "Refresh token failed") {
              throw error;
            }
            if (error.data && !!error.data.dtoRes && "dtoError" in error.data.dtoRes && "errorCode" in error.data.dtoRes.dtoError) {
              $log.debug(`Errore di comunicazione col BE: ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
              try {
                ValidazioneService.addBackEndError(error.data.dtoRes.dtoError.errorCode, error.data.dtoRes.dtoError.errorMessage);
              } catch (e) {
                $log.debug(`Stringa di errore non trovata per l'errore ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
                ValidazioneService.addTranslatedError("t.error.generic");
              }
            } else {
              $log.debug(`Errore di comunicazione col BE: errore generico`);
              ValidazioneService.addTranslatedError("t.error.generic");
            }
            throw error;
          });
      },
      invokeWebApiGet: (servicePath, filterParams,  isBackground = false, responseType) => {
        $rootScope.$broadcast('xhr');
        const url = !servicePath.includes(Environment.endPoints.baseUrl) ? Environment.endPoints.baseUrl+servicePath : servicePath;
        $log.debug(`url Servizio: ${url}`);

        const extraOptions = {};
        
       if (isBackground === true) {
          extraOptions.isBackground = true;
        } else {
          extraOptions.isBackground = false;
        }

        extraOptions.params = filterParams;

        //extraOptions.ignoreAuthModule = true;
        extraOptions.customErrorManagement = true;
        extraOptions.headers = [];   
        extraOptions.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token'); 
        if(responseType == "arraybuffer" || responseType == "blob") extraOptions.responseType = responseType;
        NewTokenService.setLastUserAction();
        return $http.get(url, extraOptions)
          .success(function(response, status, headers, config){
            return response;
          }).error(function(error, status, headers, config){
            if(error.status == 401 || error === "Token has expired."){
              $rootScope.$broadcast('event:auth-renewTokenRequired');
            }
            if (error === "Refresh token failed") {
              throw error;
            }
            if (error.data && !!error.data.dtoRes && "dtoError" in error.data.dtoRes && "errorCode" in error.data.dtoRes.dtoError) {
              ValidazioneService.addBackEndError(error.data.dtoRes.dtoError.errorCode, error.data.dtoRes.dtoError.errorMessage);
              $log.debug(`Errore di comunicazione col BE: ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
            } else {
              ValidazioneService.addTranslatedError("t.error.generic");
              $log.debug(`Errore di comunicazione col BE: errore generico`);
            }
            throw error;
          });
      },
      invokeWebApiPatch: function(servicePath, dataRequest, isBackground) {
        $rootScope.$broadcast('xhr');
        const url = Environment.endPoints.baseUrl+servicePath;
        $log.debug(`url Servizio: ${url}`);
        dataRequest = dataRequest || {}; //eslint-disable-line no-param-reassign

        const extraOptions = {};
        if (isBackground === true) {
          extraOptions.isBackground = true;
        } else {
          extraOptions.isBackground = false;
        }

       /* Headers per robo advisor*/
       extraOptions.headers = [];
       extraOptions.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token');
       NewTokenService.setLastUserAction();
        return $http.patch(url, dataRequest, extraOptions)
          .then(function(response) { //eslint-disable-line no-unused-vars
            $log.debug(response);
            return response;
          }, (error) => {
            if(error.status == 401 || error === "Token has expired."){
              $rootScope.$broadcast('event:auth-renewTokenRequired');
            }
            if (error.data === "Refresh token failed") {
              throw error;
            }
            if (error.data && !!error.data.dtoRes && "dtoError" in error.data.dtoRes && "errorCode" in error.data.dtoRes.dtoError) {
              $log.debug(`Errore di comunicazione col BE: ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
              try {
                ValidazioneService.addBackEndError(error.data.dtoRes.dtoError.errorCode, error.data.dtoRes.dtoError.errorMessage);
              } catch (e) {
                $log.debug(`Stringa di errore non trovata per l'errore ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
                ValidazioneService.addTranslatedError("t.error.generic");
              }
            } else {
              $log.debug(`Errore di comunicazione col BE: errore generico`);
              ValidazioneService.addTranslatedError("t.error.generic");
            }
            throw error;
          });
      },
      invokeWebApiPut: function(servicePath, dataRequest, customExtraOptions) {
        $rootScope.$broadcast('xhr');
        const url = Environment.endPoints.baseUrl+servicePath;
        $log.debug(`url Servizio: ${url}`);
        dataRequest = dataRequest || {}; //eslint-disable-line no-param-reassign

       const extraOptions = customExtraOptions ? customExtraOptions : { headers: {}};

       extraOptions.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token');
       NewTokenService.setLastUserAction();
        return $http.put(url, dataRequest, extraOptions)
          .then(function(response) { //eslint-disable-line no-unused-vars
            $log.debug(response);
            return response;
          }, (error) => {
            if(error.status == 401 || error === "Token has expired."){
              $rootScope.$broadcast('event:auth-renewTokenRequired');
            }
            if (error.data === "Refresh token failed") {
              throw error;
            }
            if (error.data && !!error.data.dtoRes && "dtoError" in error.data.dtoRes && "errorCode" in error.data.dtoRes.dtoError) {
              $log.debug(`Errore di comunicazione col BE: ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
              try {
                ValidazioneService.addBackEndError(error.data.dtoRes.dtoError.errorCode, error.data.dtoRes.dtoError.errorMessage);
              } catch (e) {
                $log.debug(`Stringa di errore non trovata per l'errore ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
                ValidazioneService.addTranslatedError("t.error.generic");
              }
            } else {
              $log.debug(`Errore di comunicazione col BE: errore generico`);
              ValidazioneService.addTranslatedError("t.error.generic");
            }
            throw error;
          });
      },
      invokeWebApiDelete: function(servicePath) {
        $rootScope.$broadcast('xhr');
        const url = Environment.endPoints.baseUrl+servicePath;
        $log.debug(`url Servizio: ${url}`);
        
        const extraOptions = {};
        
       extraOptions.headers = [];
       extraOptions.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token');
       NewTokenService.setLastUserAction();
        return $http.delete(url, extraOptions)
          .then(function(response) { //eslint-disable-line no-unused-vars
            $log.debug(response);
            return response;
          }, (error) => {
            if(error.status == 401 || error === "Token has expired."){
              $rootScope.$broadcast('event:auth-renewTokenRequired');
            }
            if (error.data === "Refresh token failed") {
              throw error;
            }
            if (error.data && !!error.data.dtoRes && "dtoError" in error.data.dtoRes && "errorCode" in error.data.dtoRes.dtoError) {
              $log.debug(`Errore di comunicazione col BE: ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
              try {
                ValidazioneService.addBackEndError(error.data.dtoRes.dtoError.errorCode, error.data.dtoRes.dtoError.errorMessage);
              } catch (e) {
                $log.debug(`Stringa di errore non trovata per l'errore ${error.data.dtoRes.dtoError.errorCode} ${error.data.dtoRes.dtoError.errorMessage}`);
                ValidazioneService.addTranslatedError("t.error.generic");
              }
            } else {
              $log.debug(`Errore di comunicazione col BE: errore generico`);
              ValidazioneService.addTranslatedError("t.error.generic");
            }
            throw error;
          });
      }



    }
  }
  

export default backEndServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/backend.factory.js
 **/